import { render, staticRenderFns } from "./ClassSize.vue?vue&type=template&id=2119d0dc&"
import script from "./ClassSize.vue?vue&type=script&lang=js&"
export * from "./ClassSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports